import { gql, TypedDocumentNode } from '@apollo/client';

import { PayPeriods, PayPeriodsInput } from '@atom/types/payPeriod';

export const GET_PAY_PERIODS: TypedDocumentNode<
  { payPeriods: PayPeriods },
  { input: PayPeriodsInput }
> = gql`
  query payPeriods($input: PayPeriodsInput!) {
    payPeriods(input: $input) {
      currentPeriod
      availableYears
      periods {
        period
        startDate
        endDate
      }
    }
  }
`;
